
// DYNAMIC NAV
//
//
//
//
//
//
export function initDynamicNav() {

////////////////////////////////
// DYNAMIC NAV (JQUERY)
///////////////////////////////

// search dynamic nav
const $siteNav = document.querySelector('.js-site-nav');
// only activate if dynamic nav is found
if ($siteNav) {
// Initialisierung von PriorityPlus mit Konfigurationsoptionen
const inst = priorityPlus($siteNav, {
  innerToggleTemplate: ({ toggleCount, totalCount }) => {
    // Count keklinks (extranavlinks) in overflow 
    // remove <hr> and keklinks (extranavlinks) from toggle count
    const kekLinksInOverflow = document.querySelectorAll('.meta-nav-overflow .keklink, .meta-nav-overflow .kekhr').length;
    // Subtract keks from toggle count
    const adjustedCount = toggleCount - kekLinksInOverflow;
    
    if (toggleCount && toggleCount === totalCount) {
      return `
    <div class="hamburger">
    <div class="hamburger-icon">
    <svg class="ham hamRotate ham1" viewBox="0 0 100 100" width="38">
      <path class="line top" d="m 30,33 h 40 c 0,0 9.044436,-0.654587 9.044436,-8.508902 0,-7.854315 -8.024349,-11.958003 -14.89975,-10.85914 -6.875401,1.098863 -13.637059,4.171617 -13.637059,16.368042 v 40" />
      <path class="line middle" d="m 30,50 h 40" />
      <path class="line bottom" d="m 30,67 h 40 c 12.796276,0 15.357889,-11.717785 15.357889,-26.851538 0,-15.133752 -4.786586,-27.274118 -16.667516,-27.274118 -11.88093,0 -18.499247,6.994427 -18.435284,17.125656 l 0.252538,40" />
    </svg>
    </div>
    </div>
    `;
    } else if (adjustedCount > 0) { // Only show viewmore if there are actual links in overflow
      return `
        <div class="viewmore-icon w-embed"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM18.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"></path>
        </svg></div>
        <div class="viewmore-count">` + adjustedCount + `</div>
      `;
    }
    return ''; // Return empty string if only keklinks are in overflow
  },
  // CSS-Klassen anpassen:
  classNames: {
    main: ['p-plus', 'meta-nav'],
    'primary-nav': ['p-plus__primary', 'meta-header-nav-links'],
    'toggle-btn': ['p-plus__toggle-btn', 'viewmore'],
    'overflow-nav': ['p-plus__overflow', 'meta-nav-overflow'],
  },
  // Bei weniger als 2 sichtbaren Elementen, alles in Overflow schieben:
  collapseAtCount: 1,
});

// MASTER IF OVERFLOW
// functionen für aktivierten overflow laden
inst.on('showOverflow', () => {
  addClickHandlerToHiddenDropdowns();
  // scroll deaktivieren
  lockScroll();
  preventScrollOutside(".meta-nav-overflow");
  // animate in
  setTimeout(() => {
    $('.meta-nav-overflow').addClass('show'); 
  }, 100);
});

// MASTER IF NOOVERFLOW
// functionen für aktivierten overflow laden
inst.on('hideOverflow', () => {
  //animate out
   setTimeout(() => {
    $('.meta-nav-overflow').removeClass('show');
  }, 100);
  // functionen für versteckten overflow laden
  removeClickHandlerFromHiddenDropdowns();
  // scroll wieder aktivieren
  unlockScroll();
  removeScrollPrevention();
});



// ADDITIONAL NAV FUNCTIONS FOR DYNAMIC NAV
// DROPDOWNS ETC.

// Klick ins Nix
function klickWatch($activated) {
  if ($activated === true) {
    $(document).on('click.killKlickWatch', function(event) { 
      event.stopPropagation();
      if (!event.target.matches('[data-overflow-nav], [data-overflow-nav] *, [data-toggle-btn], [data-toggle-btn] *')) {
        inst.setOverflowNavOpen(false);
      }
    });
  } else {
    $(document).off('click.killKlickWatch');
  }
}

// Dropdown Keyboard Navigation
document.querySelectorAll('.metadrop-btn').forEach(button => {
  const dropdown = button.closest('.metadrop');
  const dropdownList = dropdown.querySelector('.metadrop-list');
  
  button.setAttribute('aria-haspopup', 'true');
  button.setAttribute('aria-expanded', 'false');
  
  // Click to open/close dropdown
  button.addEventListener('click', function(event) {
    event.stopPropagation();
    toggleDropdown(button, dropdownList);
  });

  // Keyboard navigation
  button.addEventListener('keydown', function(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      toggleDropdown(button, dropdownList);
    }
  });

  // Close dropdown when focus moves outside
  dropdownList.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      closeDropdown(button, dropdownList);
    }
  });

  document.addEventListener('focusin', function(event) {
    if (!event.target.closest('.metadrop')) {
      closeDropdown(button, dropdownList);
    }
  });
});

function toggleDropdown(button, dropdownList) {
  const expanded = button.getAttribute('aria-expanded') === 'true';
  const open = !expanded;
  button.setAttribute('aria-expanded', open);
  dropdownList.classList.toggle('visible');
  const metadrop = button.closest('.metadrop');
  const icon = metadrop && metadrop.querySelector('.metadrop-icon');
  if (icon) {
    icon.classList.toggle('flipped', open);
  }
}

function closeDropdown(button, dropdownList) {
  button.setAttribute('aria-expanded', 'false');
  dropdownList.classList.remove('visible');
  const metadrop = button.closest('.metadrop');
  const icon = metadrop && metadrop.querySelector('.metadrop-icon');
  if (icon) {
    icon.classList.remove('flipped');
  }
}

// HIDE OVERFLOW FUNCTIONS -> Remove Clicks + ADD Hover + MORE
function removeClickHandlerFromHiddenDropdowns() {
  // clean first
  $('.metadrop-list').addClass('out').removeClass('visible');
  $('.metadrop-icon').removeClass('flipped');
  // 
  $('.metadrop').off('click');
  $('.metadrop').hover(hoverIN, hoverOut);
  $('.metadrop').removeClass('fulldrop');
  $('.metadrop-list').removeClass('clicklist');
  $('.ham1').toggleClass('active');
  $('.meta-mobile-only-cta-button').removeClass('showcta');
  klickWatch(false);
}

// SHOW OVERFLOW FUNCTIONS -> Remove Hover + ADD Click + MORE
function addClickHandlerToHiddenDropdowns() {
  // clean first
  $('.metadrop-list').addClass('out').removeClass('visible');
  $('.metadrop-icon').removeClass('flipped');
  $('.metadrop').unbind('mouseenter').unbind('mouseleave');
  //
  $('.metadrop').click(function(event) {
    event.stopPropagation();
    $(this).find('.metadrop-list').toggleClass('visible').toggleClass('out');
    $(this).find('.metadrop-icon').toggleClass('flipped');
  });
  $('.metadrop-list').addClass('clicklist');
  $('.metadrop').addClass('fulldrop');
  $('.ham1').toggleClass('active');
  $('.meta-mobile-only-cta-button').addClass('showcta');
  klickWatch(true);
}

// hoverstuff

function hoverIN() {
  const $list = $(this).find('.metadrop-list');
  const $button = $(this).find('.metadrop-btn button');
  $list.addClass('visible').delay(10).queue(function(next) {
    $(this).removeClass('out'); next();
  });
  $(this).find('.metadrop-icon').addClass('flipped');
  $button.attr('aria-expanded', 'true'); // Set aria-expanded to true on hover
}

function hoverOut() {
  const $list = $(this).find('.metadrop-list');
  const $button = $(this).find('.metadrop-btn button');
  $list.addClass('out').delay(10).queue(function(next) {
    $(this).removeClass('visible'); next();
  });  
  $(this).find('.metadrop-icon').removeClass('flipped');
  $button.attr('aria-expanded', 'false'); // Set aria-expanded to false when hover ends
}

// Language Button Stuff

const languageButton = document.getElementById('languageButton');
const languageListbox = document.getElementById('languageListbox');

if (languageButton && languageListbox) {
  const languageWrapper = languageButton.closest('.meta-languages');
  const languageOptions = languageListbox.querySelectorAll('[role="menuitem"]');

  // Toggle language dropdown on button click
  languageButton.addEventListener('click', function(event) {
    event.stopPropagation();
    const expanded = this.getAttribute('aria-expanded') === 'true';
    this.setAttribute('aria-expanded', !expanded);
    languageWrapper.classList.toggle('showlangs');

    if (!expanded && languageOptions.length > 0) {
      languageOptions[0].focus();
    }
  });

  // Close dropdown if clicking outside of it
  document.addEventListener('click', function(event) {
    if (!event.target.closest('.meta-languages')) {
      languageButton.setAttribute('aria-expanded', 'false');
      languageWrapper.classList.remove('showlangs');
    }
  });

  // Keyboard navigation for language dropdown
  languageListbox.addEventListener('keydown', function(event) {
    const items = Array.from(languageOptions);
    let index = items.indexOf(document.activeElement.closest('[role="menuitem"]'));

    switch (event.key) {
      case 'ArrowUp':
        event.preventDefault();
        index = index > 0 ? index - 1 : items.length - 1;
        items[index].focus();
        break;
      case 'ArrowDown':
        event.preventDefault();
        index = index < items.length - 1 ? index + 1 : 0;
        items[index].focus();
        break;
      case 'Home':
        event.preventDefault();
        items[0].focus();
        break;
      case 'End':
        event.preventDefault();
        items[items.length - 1].focus();
        break;
      case 'Escape':
        event.preventDefault();
        languageButton.setAttribute('aria-expanded', 'false');
        languageWrapper.classList.remove('showlangs');
        languageButton.focus();
        break;
      case 'Tab':
        if (event.shiftKey && index === 0) {
          event.preventDefault();
          languageButton.setAttribute('aria-expanded', 'false');
          languageWrapper.classList.remove('showlangs');
          languageButton.focus();
        }
        break;
    }
  });

  // Close listbox when focus moves out of the component
  document.addEventListener('focusin', function(event) {
    if (!event.target.closest('.meta-languages')) {
      languageButton.setAttribute('aria-expanded', 'false');
      languageWrapper.classList.remove('showlangs');
    }
  });
}


// Init Dropdowns for Dynamic Nav (!)
$('.metadrop').hover(hoverIN, hoverOut);

} // end only activate if dynamic nav is found

} // end module